export const GlobalInjectionPlugin = {
  install(app) {
    app.mixin({
      data() {
        return {
          //
        };
      }
    });
  }
};
